__turbopack_context__.v({
  "helios-spinner": "Uyl3Ma_helios-spinner",
  "helios-spinner--animating": "Uyl3Ma_helios-spinner--animating",
  "helios-spinner--brand": "Uyl3Ma_helios-spinner--brand",
  "helios-spinner--default": "Uyl3Ma_helios-spinner--default",
  "helios-spinner--lg": "Uyl3Ma_helios-spinner--lg",
  "helios-spinner--md": "Uyl3Ma_helios-spinner--md",
  "helios-spinner--sm": "Uyl3Ma_helios-spinner--sm",
  "helios-spinner--white": "Uyl3Ma_helios-spinner--white",
  "helios-spinner__blade": "Uyl3Ma_helios-spinner__blade",
  "i-spinner-blade": "Uyl3Ma_i-spinner-blade",
});
